// @ts-nocheck
import React, { useEffect, useState } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import { customVfs } from "../../../assets/CustomVfsFonts";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import moment from "moment/moment";
import { convert as convertNumberToWordsRu } from 'number-to-words-ru' // ES6

const GenerateInvoice = ({isShowContract=false,setGeneratedInvoice, request, contract}) => {
  const now = moment();
  const [pdfUrl, setPdfUrl] = useState(null);
  pdfMake.vfs = {
    ...pdfMake.vfs,
    ...customVfs,
  };

  pdfMake.fonts = {
    ...pdfMake.fonts,
    TimesNewRoman: {
      normal: "TimesNewRoman.ttf",
      bold: "TimesNewRomanBold.ttf",
      italics: "TimesNewRomanItalic.ttf",
      bolditalics: "TimesNewRomanBoldItalic.ttf",
    },
  };

  const totalSum = request?.invoice.reduce((sum, item) => {
    return sum + parseFloat(item.total);
  }, 0);
  const onBehalf = request?.customer?.long_term ? `Договор № ${request?.customer.long_term_number} от ${request?.customer?.long_term_start}` : `Договор № ${request?.payment?.id} от ${now.format('DD.MM.YYYY')}`
  const generateInvoice = () => {
    const docDefinition = {
      content: [
        {
          table: {
            widths: ['50%', '15%', '35%'],
            body: [
              [
                {
                  stack: [
                    { text: 'АО «АЛЬФА-БАНК» г. Москва' },
                    { text: '\n' },
                    { text: 'Банк получателя' }
                  ],
                  border: [true, true, true, true]
                },
                {
                  stack: [
                    { text: 'БИК' },
                    {
                      canvas: [
                        { type: 'line', x1: -5, y1: 0, x2: 73, y2: 0, lineWidth: 0.5 }
                      ]
                    },
                    { text: 'Сч. №' }
                  ],
                  border: [true, true, true, false]
                },
                {
                  stack: [
                    { text: '044525593', margin: [0, 0, 0, 0] },
                    { text: '30101810200000000593' }
                  ],
                  border: [true, true, true, true]
                }
              ],
              [
                [
                  {
                    columns: [
                      { text: `ИНН    ${!request?.customer?.long_term ? '7736314094' : request?.customer?.long_term && new Date(request?.customer?.long_term_date) > new Date() && request?.customer?.city === "Москва" ? '9728036841' : '9728036834'}`, width: '49%' },
                      {
                        canvas: [
                          { type: 'line', x1: 0, y1: -2, x2: 0, y2: 15, lineWidth: 0.5 }
                        ],
                        width: '2%'
                      },
                      { text: `КПП     ${!request?.customer?.long_term ? '773601001' : '772801001'}`, width: '49%' }
                    ],
                    border: [true, true, true, true]
                  }
                ],
                { text: 'Сч. №', border: [true, true, true, false]},
                { text: `${!request?.customer?.long_term ? '40702810301300015172' : request?.customer?.long_term && new Date(request?.customer?.long_term_date) > new Date() && request?.customer?.city === "Москва" ? '40702810601850002791' : '40702810201850002793'}`, border: [false, false, true, false]}
              ],
              [
                {
                  stack: [
                    { text: `${!request?.customer?.long_term ? 'ООО «МЕДИТ Групп»' : request?.customer?.long_term && new Date(request?.customer?.long_term_date) > new Date() && request?.customer?.city === "Москва" ? 'ООО "МК ИМПРОМЕД"' : 'ООО "СМП ЦЕНТР"'}`},
                    { text: '\n' },
                    { text: 'Получатель' }
                  ],
                  border: [true, true, true, true]
                },
                { text: '', bold: true, border: [false, false, false, true] },
                { text: '', border: [true, false, true, true] }
              ]
            ]
          },
          layout: {
            hLineWidth: () => 1,
            vLineWidth: () => 1
          },
          fontSize: 10,
          margin: [0, 0, 0, 10]
        },

        {
          text: `Счет на оплату № ${request?.payment?.id} от ${contract && contract.created_at ? moment(contract.created_at).format('DD') :now.format('DD')} ${contract && contract.created_at ? moment(contract.created_at).format('MM') :now.format('MM')} ${contract && contract.created_at ? moment(contract.created_at).format('YYYY') :now.format('YYYY')} г.`,
          alignment: "left",
          style: "header",
          margin: [0, 0, 0, 0],
        },
        {
          canvas: [
            {
              type: 'line',
              x1: 0, y1: 0,
              x2: 515, y2: 0, // width of the page
              lineWidth: 2 // thickness
            }
          ],
          margin: [0, 10, 0, 10] // optional spacing around the line
        },
        {
          columns: [
            {
              width: '15%',
              stack: [
                { text: 'Поставщик\n(Исполнитель):', margin: [0, 0, 0, 10], fontSize: 11 },
                { text: 'Покупатель\n(Заказчик):', margin: [0, 0, 0, 10], fontSize: 11 },
                { text: 'Основание:', margin: [0, 0, 0, 10], fontSize: 11 }
              ]
            },
            {
              width: '85%',
              stack: [
                { text: `${!request?.customer?.long_term ?
                    "ООО «МЕДИТ Групп», ИНН: 7736314094, КПП: 773601001, 119296, г. Москва, Ломоносовский пр-т, д. 18, этаж 1 пом XXIX ком 1-5, телефон: 8-964-537-22-53"
                    : request?.customer?.long_term && new Date(request?.customer?.long_term_date) > new Date() && request?.customer?.city === "Москва" ? "ООО \"МК ИМПРОМЕД\", ИНН 9728036841, КПП 772801001, 117393, Москва г, ул Профсоюзная, д. 56, тел.: 8-495-987-47-01" : "ООО \"СМП ЦЕНТР\", ИНН 9728036834, КПП 781445001, 117393, Москва г, вн.тер.г. муниципальный округ Обручевский, ул Профсоюзная, д. 56, этаж 5, помещ. XXIII, ком. 60, тел.: 8-495-987-47-01"}`,bold: true, margin: [0, 0, 0, 10], fontSize: 11 },
                { text: `${request?.customer?.organization_name}, ИНН: ${request?.customer?.taxpayer_number}, БИК: ${request?.customer?.bic}, Юридический адрес: ${request?.customer?.address}, телефон: ${request?.customer?.primary_phone}`,bold: true, margin: [0, 0, 0, 10], fontSize: 11 },
                { text: `${onBehalf}`, bold: true, margin: [0, 0, 0, 0], fontSize: 11 }
              ]
            }
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0]
        },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*", "auto", "auto", "auto", "auto"],
            body: [
              [
                { text: "№", style: "tableHeader" },
                { text: "Товары (работы, услуги)", style: "tableHeader" },
                { text: "Кол-во", style: "tableHeader" },
                { text: "Ед.", style: "tableHeader" },
                { text: "Цена", style: "tableHeader" },
                { text: "Сумма", style: "tableHeader" },
              ],
              ...request?.invoice.map((item, index) => [
                { text: `${index + 1}`, border: [true, true, true, true] },
                { text: item.text, border: [true, true, true, true] },
                { text: item.qty, border: [true, true, true, true] },
                { text: item.eta, border: [true, true, true, true] },
                { text: item.price, border: [true, true, true, true] },
                { text: item.total, border: [true, true, true, true] }
              ])
            ]
          },
          layout: {
            hLineWidth: () => 1,
            vLineWidth: () => 1
          },
          margin: [0, 0, 0, 10]
        },
        {
          columns: [
            {
              width: '60%',
              text: '',
              margin: [0, 0, 0, 0]
            },
            {
              width: '40%',
              columns: [
                {
                  width: '50%',
                  stack: [
                    {
                      text: `Итого: `,
                      style: 'bold',
                      margin: [0, 0, 0, 0]
                    },
                    {
                      text: 'Без налога (НДС)',
                      style: 'bold',
                      margin: [0, 0, 0, 0]
                    },
                    { text: `Всего к оплате: `,
                      style: "bold",
                      margin: [0, 0, 0, 0]
                    }
                  ]
                },
                {
                  width: '50%',
                  stack: [
                    {
                      text: `${totalSum.toFixed(2)}`,
                      style: 'bold',
                      alignment: 'right',
                      margin: [0, 0, 0, 0]
                    },
                    {
                      text: '-',
                      style: 'bold',
                      alignment: 'right',
                      margin: [0, 0, 0, 0]
                    },
                    { text: `${totalSum.toFixed(2)}`,
                      style: "bold",
                      alignment: 'right',
                      margin: [0, 0, 0, 0]
                    }
                  ]
                }
              ]
            }
          ]
        },
        { text: `Всего наименований ${request?.invoice.length}, на сумму: ${totalSum.toFixed(2)} руб.`, margin: [0, 0, 0, 0] },
        { text: `${convertNumberToWordsRu(totalSum)}`, style: "bold", margin: [0, 0, 0, 20] },

        // {
        //   ul: [
        //     "Оплата данного счета означает согласие Заказчика с условиями оказания услуг:",
        //     "1. Исполнитель обязуется оказать Заказчику услуги, а Заказчик обязуется их принять и оплатить.",
        //     "2. Сведения об оказываемых услугах содержатся в настоящем счете.",
        //     "3. Оплата услуг осуществляется Заказчиком путем безналичного перевода денежных средств на расчетный счет Исполнителя с обязательным указанием в платежном поручении реквизитов настоящего счета.",
        //     "4. Заказчик обязуется оплатить услуги в размере 100% в течение 3 рабочих дней.",
        //     "5. Приемка оказанных услуг осуществляется путем подписания Заказчиком и Исполнителем акта об оказании услуг.",
        //   ],
        //   fontSize: 10,
        //   margin: [0, 0, 0, 20]
        // },
        {
          canvas: [
            {
              type: 'line',
              x1: 0, y1: 0,
              x2: 515, y2: 0, // width of the page
              lineWidth: 2 // thickness
            }
          ],
          margin: [0, 70, 0, 20]
        },
        {
          columns: [
            { width: "50%", text: `Руководитель: ${request?.customer?.long_term && new Date(request?.customer?.long_term_date) > new Date() ? "_____________ Саруханян О. О." : "_____________ Вадачкория А. Г." }`, margin: [0, 20, 0, 0] },
            { width: "50%", text: "Бухгалтер: _____________ Борисова Е. И.", alignment: "right", margin: [0, 20, 0, 0] },
          ],
        },
      ],
      styles: {
        header: { fontSize: 16, bold: true, font: "TimesNewRoman" },
        bold: { bold: true, font: "TimesNewRoman" },
        tableHeader: {
          bold: true,
          fillColor: "#eeeeee",
          alignment: "center",
          font: "TimesNewRoman",
          fontSize: 12
        },
      },
      defaultStyle: {
        font: "TimesNewRoman",
        fontSize: 12,
      },
      footer: (currentPage, pageCount) => ({
        text: `${currentPage} из ${pageCount}`,
        alignment: "center",
        fontSize: 9,
        margin: [0, 10, 0, 0],
      }),
    };


    pdfMake.createPdf(docDefinition).getBlob((blob) => {
      const url = URL.createObjectURL(blob);
      setPdfUrl(url);
      setGeneratedInvoice(blob)
    });


  };

  useEffect(() => {
    generateInvoice();
  }, []);
  return (
    <div style={{ height: "100%" }}>
      {pdfUrl && (
        <iframe
          src={pdfUrl}
          title="GenerateInvoice PDF"
          style={{ width: "100%", height: isShowContract?  "70vh" : "64vh", border: "none" }}
        />
      )}
    </div>
  );
};

export default GenerateInvoice;
